import { useState, useEffect } from 'react';
import { Bell } from 'lucide-react';
import { Link } from 'react-router-dom';
import api from '@/lib/api';

export default function NotificationBadge() {
  const [notifications, setNotifications] = useState({
    leads: 0,
    reviews: 0,
    bookings: 0
  });

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const [leadsRes, reviewsRes, bookingsRes] = await Promise.all([
          api.get('/admin/leads?status=nuovo'),
          api.get('/admin/reviews?status=in_attesa'),
          api.get('/admin/bookings?status=richiesta')
        ]);
        setNotifications({
          leads: leadsRes.data.length,
          reviews: reviewsRes.data.length,
          bookings: bookingsRes.data.filter(b => 
            b.status === 'richiesta' || b.status === 'modifica_richiesta'
          ).length
        });
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    };

    fetchNotifications();
    // Refresh every 30 seconds
    const interval = setInterval(fetchNotifications, 30000);
    return () => clearInterval(interval);
  }, []);

  const total = notifications.leads + notifications.reviews + notifications.bookings;

  if (total === 0) return null;

  return (
    <div className="relative" data-testid="notification-badge">
      <Bell size={20} />
      <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-medium">
        {total > 9 ? '9+' : total}
      </span>
    </div>
  );
}
